import React, { useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import { FORM_CLASSIFIERS_PRODUCTION_TECHNOLOGY_EDIT } from '../../constants/formKeys';
import {
  getClassifiersProductionTechnologyChange,
  getClassifiersProductionTechnologyItem,
  getClassifiersProductionTechnologyItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { productionTechnology } from '../../constants/parameters';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

const ProductionTechnologyEdit = ({
  t,
  fetchClassifierProductionTechnology,
  changeClassifierProductionTechnology,
  fetchClassifierProductionTechnologyList,
  isLoading,
  operatorCode,
  onCancel,
  onComplete,
  initialValues: initialValuesProp,
}) => {
  useEffect(() => {
    if (operatorCode) {
      fetchClassifierProductionTechnology(operatorCode);
    }
  }, [operatorCode, fetchClassifierProductionTechnology]);

  // Convert Immutable Map to plain JS
  const initialValues = initialValuesProp?.toJS
    ? initialValuesProp.toJS()
    : initialValuesProp || {
        [productionTechnology.CODE]: '',
        [productionTechnology.LANG]: {
          [productionTechnology.ENGLISH]: '',
          [productionTechnology.ESTONIAN]: '',
        },
      };

  const validate = makeRffValidateFromLegacy(
    validateSchema,
    { t },
    initialValues
  );

  const onSubmit = async (values) => {
    const result = await changeClassifierProductionTechnology(values);

    if (!result.error) {
      notification.info({
        message: t('completeTitle'),
        description: t('completeBody'),
      });

      onComplete();
    }

    await fetchClassifierProductionTechnologyList();
    await classifiersStore.update();
  };

  return (
    <Spin spinning={isLoading}>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FormStateToRedux
              form={FORM_CLASSIFIERS_PRODUCTION_TECHNOLOGY_EDIT}
            />
            <Row gutter={32}>
              <Col span={24}>
                <Field
                  name={productionTechnology.CODE}
                  label={t('fieldCode')}
                  component={TextField}
                  disabled={!!operatorCode}
                  required
                />
              </Col>
            </Row>
            <Row gutter={32}>
              <Col span={12}>
                <Field
                  name={`${productionTechnology.LANG}.${productionTechnology.ENGLISH}`}
                  label={t('fieldEn')}
                  component={TextField}
                  required
                />
              </Col>
              <Col span={12}>
                <Field
                  name={`${productionTechnology.LANG}.${productionTechnology.ESTONIAN}`}
                  label={t('fieldEt')}
                  component={TextField}
                  required
                />
              </Col>
            </Row>
            <FormActions>
              <Button onClick={onCancel}>{t('buttonCancel')}</Button>
              <Button htmlType="submit" type="primary">
                {t('buttonSave')}
              </Button>
            </FormActions>
          </form>
        )}
      />
    </Spin>
  );
};

ProductionTechnologyEdit.propTypes = {
  t: PropTypes.func.isRequired,
  fetchClassifierProductionTechnology: PropTypes.func.isRequired,
  changeClassifierProductionTechnology: PropTypes.func.isRequired,
  fetchClassifierProductionTechnologyList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  operatorCode: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

const getIsLoading = getLoadingSelector(
  getClassifiersProductionTechnologyChange,
  getClassifiersProductionTechnologyItem
);

const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.operatorCode
    ? getClassifiersProductionTechnologyItemData(state)
    : null,
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  fetchClassifierProductionTechnology:
    actions.fetchClassifierProductionTechnology,
  changeClassifierProductionTechnology:
    actions.changeClassifierProductionTechnology,
  fetchClassifierProductionTechnologyList:
    actions.fetchClassifierProductionTechnologyList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductionTechnologyEdit);
